import { Action } from '@/_core/fluxstore/types';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';

const { registerReducer } = useStorymapStore();

export class DeleteNewRelease extends Action<StorymapState> {
    public static ACTION_TYPE = 'DeleteNewRelease';

    public constructor(public id: string) {
        super(DeleteNewRelease.ACTION_TYPE);
    }
}

const reducer = (state: StorymapState, action: DeleteNewRelease): void => {
    const release = state.releases.find((x) => x.id === action.id);

    state.releases.filter((x) => x.order > release.order).forEach((x) => x.order--);

    state.releases = state.releases.filter((x) => x.id !== action.id);
};

//@ts-ignore
registerReducer(DeleteNewRelease.ACTION_TYPE, reducer);
